/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import {
  FormControl,
  Typography,
  Select,
  InputLabel,
  MenuItem,
  Input,
  Paper,
  TableContainer,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  Button,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";

// components
import MainLayout from "../components/hoc/MainLayout";
import Loader from "react-loader";
import { apiGet, apiPost, apiDelete } from "../helpers/api";

const useStyles = makeStyles((theme) => ({
  formControl: {
    minWidth: 120,
    marginLeft: "5px",
    marginTop: "16px",
    marginBottom: "8px",
  },
  selectEmpty: {
    marginTop: theme.spacing(2),
  },
  table: { minWidth: 650 },
  noResults: { fontStyle: "italic", color: "#b99d9d" },
  filterButton: {
    fontSize: "small",
  },
}));

function AccessControl(props) {
  const classes = useStyles();

  const [selectedRole, setSelectedRole] = useState("");
  const [roles, setRoles] = useState([]);
  const [modules, setModules] = useState([]);
  const [roleModules, setRoleModules] = useState([]);

  const ITEM_HEIGHT = 48;
  const ITEM_PADDING_TOP = 8;
  const MenuProps = {
    PaperProps: {
      style: {
        maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
        width: 250,
      },
    },
  };

  const fetchRoles = async () => {
    // get data from api
    try {
      const response = await apiGet(`/references/roles`);
      setRoles(response.data);
    } catch (e) {
      console.log(e.response?.data?.message);
    }
  };

  const fetchModules = async () => {
    // get data from api
    try {
      const response = await apiGet(`/references/modules`);
      setModules(response.data);
    } catch (e) {
      console.log(e.response?.data?.message);
    }
  };

  const fetchRoleModules = async () => {
    console.log("fetching role modules", selectedRole);
    if (selectedRole) {
      // get data from api
      try {
        const response = await apiGet(
          `/references/roles/${selectedRole}/modules`
        );
        console.log("role modules:", response.data);
        setRoleModules(response.data);
      } catch (e) {
        console.log(e.response?.data?.message);
      }
    } else {
      console.log("clear role modules");
    }
  };

  useEffect(() => {
    fetchRoleModules();
  }, [selectedRole]);

  useEffect(() => {
    fetchRoles();
    fetchModules();
  }, []);

  const assignRoleToModule = (moduleId) => async (e) => {
    console.log(`Assign role ${selectedRole} to module ${moduleId}`);
    try {
      const response = await apiPost(
        `/references/roles/${selectedRole}/modules`,
        {
          module_id: moduleId,
        }
      );
      console.log("assign", response.data);
    } catch (e) {
      console.log(e.response?.data?.message);
    }

    const tempRoleModules = roleModules;
    const index = modules.findIndex((el) => el.id === moduleId);
    const module = modules[index];

    tempRoleModules.push(module);
    tempRoleModules.push({ id: -100 });

    setRoleModules(tempRoleModules);
    unassignRoleToModule(-100)(null);
  };

  const unassignRoleToModule = (moduleId) => async (e) => {
    try {
      if (moduleId !== -100) {
        const response = await apiDelete(
          `/references/roles/${selectedRole}/modules/${moduleId}`
        );

        console.log("unassign", response.data);
      }
      setRoleModules(roleModules.filter((el) => el.id !== moduleId));
    } catch (e) {
      console.log(e.response?.data?.message);
    }
  };

  const renderButton = (moduleId) => {
    const index = roleModules.findIndex((el) => {
      return el.id === moduleId;
    });

    if (moduleId === 1) {
      console.log("yes", moduleId, index);
    }

    return (
      <Button
        variant="contained"
        className={classes.filterButton}
        onClick={
          index >= 0
            ? unassignRoleToModule(moduleId)
            : assignRoleToModule(moduleId)
        }
      >
        {index >= 0 ? "Disable" : "Enable"}
      </Button>
    );
  };

  const showModules = () => {
    if (!selectedRole) {
      return null;
    }

    return (
      <TableContainer component={Paper}>
        <Table className={classes.table} aria-label="simple table">
          <TableHead>
            <TableRow>
              <TableCell align="left">Name</TableCell>
              <TableCell align="left">Description</TableCell>
              <TableCell align="left">Action</TableCell>
            </TableRow>
          </TableHead>

          <TableBody>
            {modules?.length === 0 && (
              <TableRow>
                <TableCell align="center" colSpan={3}>
                  <span className={classes.noResults}>No results found</span>
                </TableCell>
              </TableRow>
            )}
            {modules.map((module) => (
              <TableRow key={module.id} style={{ verticalAlign: "top" }}>
                <TableCell align="left">{module.display_name}</TableCell>
                <TableCell align="left">{module.description}</TableCell>
                <TableCell align="left">{renderButton(module.id)}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    );
  };

  return (
    <Loader loaded={roles !== [] && modules !== []}>
      <Typography variant="h5" gutterBottom>
        Access Control
      </Typography>

      <FormControl className={classes.formControl}>
        <InputLabel id="select-role-label">Select Role</InputLabel>
        <Select
          labelId="select-role-label"
          id="role"
          value={selectedRole}
          onChange={(e) => {
            setSelectedRole(e.target.value);
          }}
          input={<Input />}
          MenuProps={MenuProps}
        >
          {roles.map((role) => {
            return (
              <MenuItem key={role.id} value={role.id}>
                {role.display_name}
              </MenuItem>
            );
          })}
        </Select>
      </FormControl>
      {showModules()}
    </Loader>
  );
}

export default MainLayout(AccessControl);
